import React, { useEffect, useState } from "react";
import api from "../../api/api";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
const RpmNote = ({ isOpen, onClose, selectedCard,setToastMessage ,setToastSeverity,setOpenToast}) => {
  const [notes,setNotes]=useState([])
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const practiseid = window.getPracticeId();

  const [formData, setFormData] = useState({
    category: "",
    timeSpent: "",
    notes: "",
  });
  useEffect(()=>{
    if(isOpen){
      fetchRpmNote(selectedCard)
    }
  },[isOpen])
let user=localStorage.getItem('user')
  const [errors, setErrors] = useState({
    category: false,
    timeSpent: false,
    notes: false,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: false, // Reset error state when the field changes
    });
  };

  const handleSubmit = async () => {
    const newErrors = {
      category: !formData.category,
      timeSpent: !formData.timeSpent,
      notes: !formData.notes,
    };

    setErrors(newErrors);

    if (!Object.values(newErrors).includes(true)) {
      setIsSubmitting(true);
      try {
        const response = await api.post(
          `/v1/${practiseid}/patient/${selectedCard?.patientid}/rpm/create-patient-notes`,
          {
            notes: formData.notes,
            category: formData.category,
            created_by: user,
            type: "rpminternal",
            tat: Number(formData.timeSpent),
            status: 1,
          }
        );

        if (response.status === 200) {
          setToastMessage(response.message);
          setToastSeverity('success');
          setOpenToast(true);

          setTimeout(() => onClose(false), 2000);
        }
      } catch (error) {
          setToastMessage('Something went wrong');
  setToastSeverity('error');
  setOpenToast(true);
        console.error("Error submitting form:", error);

      } finally {
        setFormData({
          category: "",
          timeSpent: "",
          notes: "",
        })
        setIsSubmitting(false);
        
      }
    }
  };

 const fetchRpmNote = async (selectedCard) => {
  try {
    console.log('Fetching data for patient ID:', selectedCard.patientid); // Log the patient ID for debugging
    const response = await api.get(`/v1/${practiseid}/patient/${selectedCard.patientid}/rpm/patient-notes`);
  // 
    if (response.status === 200) {
      setNotes(response.data);
      console.log('Fetched Notes:', response.data); // Log fetched data
    } else {
      setNotes([]);
    }
  } catch (error) {
    console.log('Error fetching data:', error);
    setNotes([]); // If error occurs, reset the notes
  } finally {
  }
};


  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 h-auto overflow-scroll custom-scrollbar">
          <div className="bg-white rounded-lg shadow-lg w-full lg:max-w-[45%] max-w-[90%] mx-4 sm:mx-auto my-4">
            <div className="flex justify-between items-center border-b p-3 bg-[#E179544A]">
              <h2 className="text-[16px] font-inter  text-[black]">Add Notes</h2>
              <button
                onClick={() => {
                  setFormData({
                    category: "",
                    timeSpent: "",
                    notes: "",
                  })
                  onClose(false)}}
                className="text-black hover:text-gray-700 text-3xl"
              >
                &times;
              </button>
            </div>

            <div >
              {/* Dropdowns Row */}
              <div className="flex gap-2 h-[100px] px-4">
                {/* Category Dropdown */}
                <div className="flex-1 max-w-[50%] mt-1 ">
                  <label className="block text-[#71717A] font-[10px] mb-2 text-left">
                    Category
                  </label>
                  <select
                    name="category"
                    value={formData.category}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300 outline-none ${
                      errors.category ? "border-red-500" : ""
                    }`}
                  >
                    <option value="">Select Category</option>
                    <option value="BPP">BPP</option>
                    <option value="CGM">CGM</option>
                    <option value="CPAP">CPAP</option>
                    <option value="WLK">WLK</option>
                    <option value="EKG">EKG</option>
                  </select>
                  {errors.category && (
                    <p className="text-red-500 text-sm ">
                      Please select a category.
                    </p>
                  )}
                </div>

                {/* Time Spent Dropdown */}
                <div className="flex-1 max-w-[50%] mt-1 ">
                  <label className="block text-[#71717A] font-[10px] mb-2 text-left">
                    Time Spent (in minutes)
                  </label>
                  <select
                    name="timeSpent"
                    value={formData.timeSpent}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300 outline-none ${
                      errors.timeSpent ? "border-red-500" : ""
                    }`}
                  >
                    <option value="">Select Time</option>
                    {[...Array(21).keys()].map((i) => (
                      <option key={i} value={i}>
                        {i} minute{i > 1 ? "s" : ""}
                      </option>
                    ))}
                  </select>
                  {errors.timeSpent && (
                    <p className="text-red-500 text-sm ">
                      Please select time spent.
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Notes Textarea */}
            <div className="px-4 mt-0 h-[180px] h-[100px]">
              <label className="block text-gray-700 font-medium mb-2 text-left">
                Notes
              </label>
              <textarea
                name="notes"
                rows="4"
                value={formData.notes}
                onChange={handleInputChange}
                className={`w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300 outline-none ${
                  errors.notes ? "border-red-500" : ""
                }`}
                placeholder="Enter your notes"
              ></textarea>
              {errors.notes && (
                <p className="text-red-500 text-sm ">
                  Please enter some notes.
                </p>
              )}
            </div>
            
            <div className="flex flex-column items-start  px-[28px] ">
            <div className="flex justify-between w-full mb-2">
            <div >History</div>
            <div className="text-[#E17954] text-sm cursor-pointer">View all History</div>
            </div>
            <div className="w-full border-[1.5px] py-1 rounded-md px-4 h-[150px] overflow-y-auto" style={{scrollbarWidth:'none'}}>
            {dataLoading ? (
                    <div className="flex justify-center items-center py-6">
                    <div class="w-8 h-8 border-4 border-t-transparent border-blue-500 border-solid rounded-full animate-spin"></div>
                 </div>
                ) : (
                  notes.map((note, index) => (
                    <div key={index} className="w-full flex mb-1">
                      <div className="flex flex-column w-full">
                        <div className="flex items-center">
                          <ArrowForwardIosIcon style={{ width: "14px", color: "orange" }} />
                          <div className="text-[#16A34A] ml-2">{note.category}</div>
                          <div className="text-[#ccc] text-sm ml-2">ALL</div>
                        </div>
             <div className="text-start">
            {note.notes.replace(/<[^>]+>/g, '')}
        </div>
                        <div className="w-full flex justify-between">
              
                          <div className=" text-[#71717A] text-sm">
                            Reviewed by {note.created_by} on {note.created_at}
                          </div>
                          <div className="flex text-[#EF4444] items-center">
                            <AccessTimeIcon style={{ width: "15px" }} />
                            <div className="text-sm ml-2">{note.tat} mins</div>
                          </div>
                        </div>
                        <hr style={{ color: 'red' }} />
                      </div>
                    </div>
                  ))
                )}
             
            </div>
            <div>

            </div>
            </div>
            {/* Buttons */}
            <div className="flex justify-end gap-4 p-4">
              <button
                onClick={() => onClose(false)}
                className="border-2 border-[#E4E4E7] text-gray-800 rounded-lg text-sm px-4 py-1  hover:bg-[red] hover:text-[white]"
                disabled={isSubmitting}
              >
                Close
              </button>
              <button
                onClick={handleSubmit}
                className={`bg-[#D97842] text-white text-sm px-6 py-2 rounded-lg ${
                  isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                }`}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Update Notes"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RpmNote;
